import { render } from "./ModulosView.vue?vue&type=template&id=4fc6ddfb&scoped=true"
import script from "./ModulosView.vue?vue&type=script&lang=js"
export * from "./ModulosView.vue?vue&type=script&lang=js"

import "./ModulosView.vue?vue&type=style&index=0&id=4fc6ddfb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc6ddfb"]])

export default __exports__